import { createColumnHelper } from "@tanstack/react-table";
import { getStatusBadge } from "../../component/table-utils/get-status-badge";
import React, { useContext } from "react";
import TableMenu from "../../component/table-utils/tableMenu";
import { CallRecord } from "../../lib/types";
import formatDate from "../../lib/utils/formatDate";
import { AuthContext } from "../../context/authContext";

const columnHelper = createColumnHelper<CallRecord>();

const NameCell = ({ row }: any) => (
  <>{`${row.original.lead_details?.firstname} ${row.original.lead_details?.lastname}`}</>
);

const CostCell =
  (profile: any) =>
  ({ row }: any) =>
    (
      <>
        {row.original.call_cost
          ? `${
              profile?.user_currency_symbol || ""
            }${row.original.call_cost.toFixed(2)}`
          : "N/A"}
      </>
    );

const StatusCell = ({ row }: any) => (
  <>{getStatusBadge(row.original.call_status)}</>
);

const DateTimeAccessor = (row: CallRecord) =>
  row.call_platform_result?.updatedAt ?? row.createdAt;

const DateTimeColumn = (header: string) =>
  columnHelper.accessor(DateTimeAccessor, {
    id: "dateTime",
    size: 150,
    header: () => <div className="flex items-center gap-1">{header}</div>,
    cell: (info) => <>{formatDate(info.getValue())}</>,
    enableSorting: true,
  });

export const BasicColumns = () => {
  const { profile } = useContext(AuthContext);
  return [
    columnHelper.display({
      id: "name",
      size: 120,
      header: "NAME",
      cell: NameCell,
    }),
    DateTimeColumn("DATE AND TIME"),
    columnHelper.display({
      id: "cost",
      size: 110,
      header: "COST",
      cell: CostCell(profile),
    }),
    columnHelper.display({
      id: "status",
      size: 110,
      header: "STATUS",
      cell: StatusCell,
    }),
  ];
};

export const MajorColumns = () => {
  const { profile } = useContext(AuthContext);
  return [
    columnHelper.display({
      id: "name",
      size: 150,
      header: "NAME",
      cell: NameCell,
    }),
    columnHelper.display({
      id: "project",
      size: 250,
      header: "CAMPAIGN",
      cell: ({ row }) => <>{row.original.campaign_details?.campaign_name}</>,
    }),
    columnHelper.display({
      id: "duration",
      size: 80,
      header: "DURATION",
      cell: ({ row }) => (
        <>
          {row.original.call_duration_minutes
            ? `${row.original.call_duration_minutes.toFixed(2)} min`
            : "N/A"}
        </>
      ),
    }),
    columnHelper.display({
      id: "cost",
      size: 80,
      header: "COST",
      cell: CostCell(profile),
    }),
    DateTimeColumn("CALL TIME"),
    columnHelper.display({
      id: "status",
      size: 110,
      header: "STATUS",
      cell: StatusCell,
    }),
    columnHelper.display({
      id: "actions",
      size: 30,
      cell: ({ row }) => (
        <div
          className="w-full flex justify-center"
          onClick={(e) => e.stopPropagation()}
        >
          <TableMenu row={row} page="calls" />
        </div>
      ),
    }),
  ];
};
